import { Typography, TypographyProps } from '@mui/material';

import { styled } from '@mui/material/styles';
import { Montserrat, RookeryBoldFont } from 'v3/styles/common';

export const BodyMediumBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 0.875rem ${RookeryBoldFont}`,
}));

export const BodyMediumRegularStyled = styled(Typography)<TypographyProps>(() => ({
  font: `500 1.125rem ${Montserrat}`,
}));
